import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button, type ButtonVariant } from '~/components/ui/Button';
import { cn } from '~/helpers/utils';
import type { AdvieskeuzeScopeType } from '~/types/common/Advieskeuze';

type SearchFieldProps = {
  name: string;
  label?: string;
  labelClass?: string;
  inputContainerClass?: string;
  inputClass?: string;
  placeholder?: string;
  buttonVariant?: ButtonVariant;
  buttonClass?: string;
  scope: AdvieskeuzeScopeType;
  onSubmitSearch: (value: string) => void;
};

const SearchField: React.FC<SearchFieldProps> = ({
  name,
  label,
  labelClass,
  inputContainerClass,
  inputClass,
  placeholder,
  buttonVariant,
  buttonClass,
  scope,
  onSubmitSearch,
}) => {
  const {
    register,
    getValues,
    formState: { errors },
  } = useFormContext();

  const inputId: string = `field-${name}`;

  const handleSearch = () => {
    const value = getValues(name);
    onSubmitSearch(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSearch();
    }
  };

  return (
    <>
      <input type="hidden" {...register(`${name}Scope`)} value={scope} />
      <div className="form-control">
        {label && (
          <label htmlFor={inputId} className={cn('form-label', labelClass)}>
            {label}
          </label>
        )}
        <div className={cn('flex gap-2', inputContainerClass)}>
          <input
            type="text"
            id={inputId}
            {...register(name)}
            placeholder={placeholder || `Zoeken in ${scope}`}
            className={cn(
              'form-input w-full !rounded-r-none !py-4',
              errors[name] && 'form-input--error',
              inputClass
            )}
            onKeyDown={handleKeyDown}
          />
          <Button
            variant={buttonVariant || 'primary'}
            type="button"
            onClick={handleSearch}
            className={buttonClass}
          >
            <FontAwesomeIcon icon={faSearch} />
            <span className="sr-only">Zoeken</span>
          </Button>
        </div>
        {errors[name] && (
          <span className="text-sm text-tomato-600">
            {errors[name]?.message?.toString()}
          </span>
        )}
      </div>
    </>
  );
};

export default SearchField;
